module.exports = __webpack_public_path__ + "static/media/discussion-question-img.a4f53df4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/discussion-question-img.jpg
// module id = 749
// module chunks = 0